var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3547 10.6623L2.19857 11.4751L0.045963 18.5794C-0.0141933 18.784 -0.0153237 19.0022 0.0427098 19.2075C0.100743 19.4127 0.21543 19.596 0.372767 19.7351C0.530104 19.8742 0.723285 19.963 0.928724 19.9907C1.13416 20.0184 1.34297 19.9838 1.52966 19.8911L19.4277 10.9461C19.5994 10.8597 19.744 10.7253 19.8452 10.5582C19.9464 10.3912 20 10.1981 20 10.0011C20 9.80405 19.9464 9.61099 19.8452 9.44391C19.744 9.27682 19.5994 9.14243 19.4277 9.05605L1.52966 0.108931C1.34297 0.0162113 1.13416 -0.0184164 0.928724 0.00927575C0.723285 0.0369679 0.530104 0.125782 0.372767 0.264874C0.21543 0.403966 0.100743 0.587319 0.0427098 0.792546C-0.0153237 0.997774 -0.0141933 1.216 0.045963 1.42057L2.19648 8.51634L10.3526 9.33128C10.5117 9.34751 10.6592 9.42417 10.7664 9.54637C10.8737 9.66858 10.9332 9.82758 10.9332 9.99247C10.9332 10.1574 10.8737 10.3164 10.7664 10.4386C10.6592 10.5608 10.5117 10.6374 10.3526 10.6537L10.3547 10.6623Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.885d235a251e5d447c186db8a79b4455.svg";
export { ForwardRef as ReactComponent };